import React from 'react';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
};
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick
}: ButtonProps) => {
  const baseStyles = 'rounded-md font-medium transition-all duration-200 inline-flex items-center justify-center';
  const variantStyles = {
    primary: 'bg-burgundy text-cream hover:bg-burgundy/90 shadow-sm hover:shadow',
    secondary: 'bg-sage text-cream hover:bg-sage/90 shadow-sm hover:shadow',
    outline: 'bg-transparent text-burgundy border-2 border-burgundy hover:bg-burgundy/10'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-24">
      {children}
    </button>;
};
export default Button;